import { createSlice } from "@reduxjs/toolkit";
import {

  addNewTag,
  deleteDocuments,
  fetchAllCategories,
  fetchAllDocument,
  fetchAllTags,
  fetchCategories,
  fetchDocumentTableColumnNames,
  fetchSubCategories,
  getAIResponse,
  saveCoreDocumentMetadata,
  saveDocument,
  saveDocumentDetails,
  saveDocumentMetadata,
  uploadDocumentFile,
  uploadImageFile,
  updateDocument,
  updateDocumentJson,
  retryDocument,
  reviewedDocumentJson
} from "./thunk";
import { toast } from "react-toastify";

const initialState = {
  tableColumnNames: [],
  documentUploadLoading: false,
  documentUploadError: null,
  uploadedDocumentResponse: null,
  imageUploadLoading: false,
  imageUploadError: null,
  uploadedImageResponse: null,
  Headerloading: false,
  loading: false,
  tagsLoading: false,
  tagsError: false,
  tagCreationLoading: false, 
  tagCreationError: null,
  metadataSubmissionLoading: false,
  metadataSubmissionError: null, 
  documentDetailsLoading: false,
  documentDetailsError: null,
  savedDocumentDetails: null,
  savedDocumentMetadata: null,
  documents: [], 
  documentsLoading: false, 
  documentsError: null,  
  categories: [],
  subCategoriesLoading: false,
  subCategories: [],
  tags: [],
  error: null,
  uploadProgress: 0,
};

const AIDocSlice = createSlice({
  name: "AIDoc",
  initialState,
  reducers: {
    // getDocuments: (state, action) => {
    //   // state.documents = action.payload.Data;
    //   const documentObj = action.payload.reduce((acc, item) => {
    //     acc[item.ID] = item;
    //     return acc;
    //   }, {});
    //   state.documents = state.documents.map((item) => documentObj[item.ID] ? documentObj[item.ID] : item)
    // },
    // getDocuments: (state, action) => {
    //   const documentObj = Object.fromEntries(
    //     action.payload.Data.map((item) => [item.ID, item])
    //   );

    //   const existingIDs = new Set(state.documents.map((d) => d.ID));

    //   state.documents = [
    //     ...action.payload.Data.filter((item) => !existingIDs.has(item.ID)),
    //     ...state.documents.map((item) => documentObj[item.ID] ?? item),
    //   ];
    // },
    getDocuments: (state, action) => {
      const data = action.payload.Data;

      // Step 1: Find deleted documents
      const deletedIDs = new Set(
        data.filter((item) => item.IsDelete).map((item) => item.ID)
      );

      // Step 2: Remove deleted docs from existing state
      const updatedDocuments = state.documents.filter(
        (doc) => !deletedIDs.has(doc.ID)
      );

      // Step 3: Continue your original merge logic (for non-deleted docs)
      const activeData = data.filter((item) => !item.IsDelete);
      const documentObj = Object.fromEntries(activeData.map((item) => [item.ID, item]));
      const existingIDs = new Set(updatedDocuments.map((d) => d.ID));

      state.documents = [
        ...activeData.filter((item) => !existingIDs.has(item.ID)),
        ...updatedDocuments.map((item) => documentObj[item.ID] ?? item),
      ];
    },
    updateFileProcessingStatus: (state, action) => {
      const { ID, JsonURL, IsProcessed, Status, ModifiedByID } = action.payload;
      state.documents = state.documents.map((doc) =>
        doc.ID == ID ? { ...doc, 
          JsonURL, 
          IsProcessed, 
          Status: Status ? Status : doc.Status,
          ModifiedByID: ModifiedByID ? ModifiedByID : doc.ModifiedByID } : doc    
      );

      // let updatedDocs = state.documents.map((doc) =>
      //   doc.ID == ID ? { ...doc, JsonURL, IsProcessed, ModifiedByID } : doc
      // );

      // // If IsProcessed = false → move updated doc to front
      // if (IsProcessed == false) {
      //   const updatedDoc = updatedDocs.find((d) => d.ID === ID);
      //   updatedDocs = [
      //     updatedDoc,
      //     ...updatedDocs.filter((d) => d.ID !== ID),
      //   ];
      // }

      // state.documents = updatedDocs;
    },
    updateLargeFileProcessingStatus: (state, action) => {
      const { ID } = action.payload;
      state.documents = state.documents.map((doc) =>
        doc.ID == ID ? { ...doc, LargeDocumentFiles: doc.LargeDocumentFiles.map((item) => ({...item, JsonURL: null, IsError: false })) } : doc    
      );
    },
    updateRetryDocumentStatus: (state, action) => {
      const { ID, UpdatedID, JsonURL } = action.payload; 
       state.documents = state.documents.map((doc) =>
        doc.ID == ID ? { ...doc, ID: UpdatedID, JsonURL: JsonURL, IsProcessed: true } : doc    
      );
    },
    clearUploadedDocumentResponse: (state) => {
      state.uploadedDocumentResponse = null;
      // state.documentUploadError = null;
      state.documentUploadLoading = false;
      state.uploadedImageResponse = null;
      state.imageUploadError = null;
      state.imageUploadLoading = false;
      state.Headerloading = false;
      state.tags = [];
      state.tagsLoading = false;
      state.tagsError = null;
      state.tagCreationLoading = false;
      state.tagCreationError = null;
      state.uploadProgress = 0;
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    setUploadError: (state, action) => {
      state.documentUploadError = action.payload; 
    },
    clearUploadError(state) {
      state.documentUploadError = null;
    }
  },
  extraReducers: (builder) => {
    builder

      // Fetch Document Table Column Names API
      .addCase(fetchDocumentTableColumnNames.pending, (state) => {
        state.Headerloading = true;
        state.error = null;
      })
      .addCase(fetchDocumentTableColumnNames.fulfilled, (state, action) => {
        state.Headerloading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchDocumentTableColumnNames.rejected, (state, action) => {
        state.Headerloading = false;
        state.error = action.payload;
      })

       // Upload Document File API
      .addCase(uploadDocumentFile.pending, (state) => {
        state.documentUploadLoading = true;
        state.uploadedDocumentResponse = null;
      })
      .addCase(uploadDocumentFile.fulfilled, (state, action) => {
        state.documentUploadLoading = false;
        state.uploadedDocumentResponse = action.payload;
        // state.documentUploadError = null; 
      })
      .addCase(uploadDocumentFile.rejected, (state, action) => {        
        state.documentUploadLoading = false;
        // state.documentUploadError = action.error.message; 
      })

       // Upload Document File API
      .addCase(uploadImageFile.pending, (state) => {
        state.imageUploadLoading = true;
        state.imageUploadError = null;
        state.uploadedImageResponse = null;
      })
      .addCase(uploadImageFile.fulfilled, (state, action) => {
        state.imageUploadLoading = false;
        state.uploadedImageResponse = action.payload;
      })
      .addCase(uploadImageFile.rejected, (state, action) => {
        state.imageUploadLoading = false;
        state.imageUploadError = action.payload; // This holds the error message
        // toast.error(typeof action.payload === 'string' ? action.payload : "Image upload failed.");
      })

      // Get All CCategories API
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Tags API
      .addCase(fetchAllTags.pending, (state) => {
        state.tagsLoading = true;
        state.tagsError = null;
      })
      .addCase(fetchAllTags.fulfilled, (state, action) => {
        state.tagsLoading = false;
        state.tags = action.payload;
      })
      .addCase(fetchAllTags.rejected, (state, action) => {
        state.tagsLoading = false;
        state.tagsError = action.payload;
      })

       // Add New Tag API
      .addCase(addNewTag.pending, (state) => {
        state.tagCreationLoading = true;
        state.tagCreationError = null;
      })
      .addCase(addNewTag.fulfilled, (state, action) => {
        state.tagCreationLoading = false;
        // Add the newly created tag to the existing tags array
        if (action.payload && action.payload.ID) { // Ensure payload is valid and has an ID
          state.tags.push(action.payload);
        }
      })
      .addCase(addNewTag.rejected, (state, action) => {
        state.tagCreationLoading = false;
        state.tagCreationError = action.payload;
        toast.error(typeof action.payload === 'string' ? action.payload : "Failed to create new tag.");
      })

      // Save Document Metadata
      .addCase(saveDocumentMetadata.pending, (state) => {
        state.metadataSubmissionLoading = true;
        state.metadataSubmissionError = null;
      })
      .addCase(saveDocumentMetadata.fulfilled, (state, action) => {
        state.metadataSubmissionLoading = false;
        state.savedDocumentMetadata = action.payload;
      })
      .addCase(saveDocumentMetadata.rejected, (state, action) => {
        state.metadataSubmissionLoading = false;
        state.metadataSubmissionError = action.payload;
        toast.error(typeof action.payload === 'string' ? action.payload : "Failed to save document metadata.");
      })

      .addCase(updateDocument.pending, (state) => {
        // state.documentsLoading = true;
        state.documentsError = null;
      })
      .addCase(updateDocument.fulfilled, (state, action) => {
        state.documentsLoading = false;
        state.documents = state.documents.map((document) => document.ID === action.payload.ID ? 
          action.payload :
          document
        );
      })
      .addCase(updateDocument.rejected, (state, action) => {
        state.documentsLoading = false;
        state.documentsError = action.payload;
        toast.error(typeof action.payload === 'string' ? action.payload : "Failed to save document metadata.");
      })

      .addCase(updateDocumentJson.pending, (state) => {
        // state.documentsLoading = true;
        state.documentsError = null;
      })
      .addCase(updateDocumentJson.fulfilled, (state, action) => {
        // state.documentsLoading = false;
        state.documents = state.documents.map((document) => document.ID == action.payload.ID ? 
          { ...document, 
            IsSaved: action.payload.IsSaved,
            Status: action.payload.Status,
            JsonURL: action.payload.JsonURL, 
            ParaLegalIDs: action.payload.ParaLegalIDs,
            ReviewedBy: action.payload.ReviewedBy,
            ReviewedByID: action.payload.ReviewedByID,
            Assigned: action.payload.Assigned
          } : document
        );
      })
      .addCase(updateDocumentJson.rejected, (state, action) => {
        // state.documentsLoading = false;
        state.documentsError = action.payload;
        toast.error(typeof action.payload === 'string' ? action.payload : "Failed to save document metadata.");
      })

      // Save Document Metadata
      .addCase(saveCoreDocumentMetadata.pending, (state) => {
        state.metadataSubmissionLoading = true;
        state.metadataSubmissionError = null;
      })
      .addCase(saveCoreDocumentMetadata.fulfilled, (state, action) => {
        state.metadataSubmissionLoading = false;
        state.savedDocumentMetadata = action.payload;
      })
      .addCase(saveCoreDocumentMetadata.rejected, (state, action) => {
        state.metadataSubmissionLoading = false;
        state.metadataSubmissionError = action.payload;
        toast.error(typeof action.payload === 'string' ? action.payload : "Failed to save document metadata.");
      })

      // Save Document Details
      .addCase(saveDocumentDetails.pending, (state) => {
        // state.documentDetailsLoading = true;
        state.documentsError = null;
      })
      .addCase(saveDocumentDetails.fulfilled, (state, action) => {
         const index = state.documents.findIndex(
          (item) => item.ID === action.payload.ID
        );

        if (index !== -1) {
          state.documents[index] = action.payload;
        }
        state.documentsError = null;

      })
      .addCase(saveDocumentDetails.rejected, (state, action) => {
        // state.documentDetailsLoading = false;
        state.documentsError = action.payload;
        toast.error(typeof action.payload === 'string' ? action.payload : "Failed to save document details.");
      })

      // Fetch All Documents
      .addCase(fetchAllDocument.pending, (state) => {
        state.documentsLoading = true;
        state.documentsError = null;
      })
      .addCase(fetchAllDocument.fulfilled, (state, action) => {
        state.documentsLoading = false;
        state.documents = action.payload;
      })
      .addCase(fetchAllDocument.rejected, (state, action) => {
        state.documentsLoading = false;
        state.documentsError = action.payload;
        toast.error(typeof action.payload === 'string' ? action.payload : "Failed to fetch documents.");
      })

      // Retry Document
      .addCase(retryDocument.pending, (state, action) => {
        state.documentsError = null;
        // const data = action.meta.arg;
        // state.documents = state.documents.map((item) => item.ID === data.DocID ? 
        // {...item, JsonURL: null, IsProcessed: false} : item);
      })
      .addCase(retryDocument.fulfilled, (state, action) => {
        // state.documents = state.documents.map((item) => item.ID === action.payload.ID ? 
        // {...item, JsonURL: null, IsProcessed: false} : item);
      })
      .addCase(retryDocument.rejected, (state, action) => {
        state.documentsError = action.payload;
      })

      // Delete Document
      .addCase(reviewedDocumentJson.pending, (state) => {
        state.error = null;
      })
      .addCase(reviewedDocumentJson.fulfilled, (state, action) => {
        const reviewedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.documents = state.documents.filter((item) => !reviewedIds.includes(item.ID));

      })
      .addCase(reviewedDocumentJson.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Document
      .addCase(deleteDocuments.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteDocuments.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.documents = state.documents.filter((item) => !deletedIds.includes(item.ID));

      })
      .addCase(deleteDocuments.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Get Sub Category
      .addCase(fetchSubCategories.pending, (state) => {
        state.subCategoriesLoading = true;
        state.subCategories = [];
        state.error = null;
      })
      .addCase(fetchSubCategories.fulfilled, (state, action) => {
        state.subCategoriesLoading = false;
        state.subCategories = action.payload;
      })
      .addCase(fetchSubCategories.rejected, (state, action) => {
        state.subCategoriesLoading = false;
        state.error = action.payload;
      })
  },
});

export const { getDocuments, updateFileProcessingStatus, updateLargeFileProcessingStatus, updateRetryDocumentStatus, clearUploadedDocumentResponse, setUploadProgress, setUploadError, clearUploadError } = AIDocSlice.actions;
export default AIDocSlice.reducer;
